"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.temperatureK = void 0;
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const temperature_1 = require("@yanzi/temperature");
const tsdb_1 = require("../tsdb");
const VariableName_1 = require("../VariableName");
exports.temperatureK = {
    __basic_data_type: true,
    __slotted_variable_name_data_type: true,
    __tsdb_data_type: true,
    __variable_name_data_type: true,
    id: 'temperatureK',
    variableName: VariableName_1.VariableName.temperatureK,
    dbTable: tsdb_1.TSDBTable.temperatureK,
    title: 'Temperature',
    icon: free_solid_svg_icons_1.faThermometerHalf,
    isSlotted: true,
    order: 2,
    graphQLSampleKey: 'temperature',
    bucketing: {
        min: 273 + 18,
        max: 273 + 28,
        numberOfBuckets: 10,
    },
    decimals: 1,
    colormap: [
        { value: 238.15, rgb: [164, 0, 255, 1] },
        { value: 273.15, rgb: [0, 36, 255, 1] },
        { value: 292.19, rgb: [35, 201, 231, 1] },
        { value: 295.13, rgb: [0, 255, 0, 1] },
        { value: 297.16, rgb: [255, 204, 0, 1] },
        { value: 308.15, rgb: [255, 0, 0, 1] },
    ],
    dataPointConverter: (x, { preferredTemperatureUnit }) => {
        const val = temperature_1.convertTemp(x, temperature_1.TemperatureUnit.kelvin, preferredTemperatureUnit);
        return Math.round(val * 10) / 10;
    },
    unit: ({ preferredTemperatureUnit }) => {
        switch (preferredTemperatureUnit) {
            case temperature_1.TemperatureUnit.kelvin:
                return 'K';
            case temperature_1.TemperatureUnit.Celsius:
                return '°C';
            case temperature_1.TemperatureUnit.Fahrenheit:
                return '°F';
            default:
                return '';
        }
    },
};
//# sourceMappingURL=temperature-k.js.map